import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  createExternalRouteRef,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { workflowComposerApiRef } from './api/WorkflowComposerApi';
import { WorkflowComposerClient } from './api/WorkflowComposerClient';
import { copilotApiRef, CopilotClient } from './api/CopilotApi';

/** External route refs — resolved at app-level via bindRoutes */
export const agentRegistryExternalRouteRef = createExternalRouteRef({
  id: 'agent-registry',
});

export const toolsRegistryExternalRouteRef = createExternalRouteRef({
  id: 'tools-registry',
});

export const workflowComposerPlugin = createPlugin({
  id: 'workflow-composer',
  routes: {
    root: rootRouteRef,
  },
  externalRoutes: {
    agentRegistry: agentRegistryExternalRouteRef,
    toolsRegistry: toolsRegistryExternalRouteRef,
  },
  apis: [
    createApiFactory({
      api: workflowComposerApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new WorkflowComposerClient({ discoveryApi, fetchApi }),
    }),
    createApiFactory({
      api: copilotApiRef,
      deps: { discoveryApi: discoveryApiRef },
      factory: ({ discoveryApi }) => new CopilotClient({ discoveryApi }),
    }),
  ],
});

export const WorkflowComposerPage = workflowComposerPlugin.provide(
  createRoutableExtension({
    name: 'WorkflowComposerPage',
    component: () =>
      import('./components/WorkflowComposerPage').then(
        m => m.WorkflowComposerPage,
      ),
    mountPoint: rootRouteRef,
  }),
);
